import './App.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import history from './history';
import { AppRouting } from './routing';
import registerServiceWorker from './registerServiceWorker';
import store from './store/store';
import './styles/_stops.scss';
import './styles/_root.scss';


// Get the application-wide store instance, prepopulating with state from the server where available.
// const initialState = window.initialReduxState;
// const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <AppRouting />
    </ConnectedRouter>
  </Provider>,
  rootElement);

if (navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations()
    .then(function(registrations) {
      for(let registration of registrations) {
        registration.unregister()
      }
    });
}
